export default "__VITE_ASSET__BRxxZA4J__"